import { render, staticRenderFns } from "./infoOrder.pug?vue&type=template&id=e54414c8&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./infoOrder.scss?vue&type=style&index=0&id=e54414c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54414c8",
  null
  
)

export default component.exports